import { Link } from "react-router"
import { DonorEmptyState } from "./components/empty-state"
import { SponsorshipStatusCard } from "./components/sponsorship-status"
import { useSponsorPortal } from "./sponsor-session-context"

export function DonorRequestPage() {
  const portal = useSponsorPortal()
  if (!portal) return null

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-forest-700">My request</p>
        <h1 className="mt-2 font-display text-3xl font-bold text-ink">Sponsorship request</h1>
        <p className="mt-2 text-sm leading-6 text-ink/65">Follow the progress of your request and see what happens next.</p>
      </div>
      {portal.sponsorshipRequest ? (
        <SponsorshipStatusCard
          request={portal.sponsorshipRequest}
          matchState={portal.matchState}
          activeMatchCount={portal.activeMatchCount}
          full
        />
      ) : (
        <DonorEmptyState
          title="No sponsorship request yet"
          description="When you submit a sponsorship request, its status and next steps will appear here."
          primaryLabel="Start a sponsorship"
          primaryTo="/sponsor"
          secondaryLabel="Back to overview"
          secondaryTo="/donor"
        />
      )}
      {portal.sponsorshipRequest && (
        <p className="text-sm text-ink/60">
          Need help with your request? <Link to="/contact" className="font-semibold text-forest-700 hover:underline">Contact Redempta</Link>.
        </p>
      )}
    </div>
  )
}
